import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./question.css";



const Question = () => {
    useEffect(() => {
        AOS.init({ duration: 1500, once: true });
      }, []);  
    return(
        <div className="questionContainer" data-aos="fade-up">
            <h4 className="questionHeader">Frequently asked questions</h4>
            <div>
                <div>
                    <h6 className="questionSmallHeader">Q: How can I quickly upgrade to Giftcard8 VIP membership? What are the requirements?</h6>
                    <article className="questionText">
                        A: You can quickly upgrade by providing your transaction records from other platforms over the past 30 days. Please submit screenshots of your transaction history to help us assess your trading volume. Based on your trading activity, we will expedite your upgrade to the corresponding VIP level, allowing you to enjoy the associated benefits as soon as possible. 
                        For specific requirements for each level, please refer to our VIP level chart.
                    </article>
                </div>
                <div>
                    <h6 className="questionSmallHeader">Q: What specific benefits will I receive after upgrading to VIP?</h6>
                    <article className="questionText">
                        A: Upon upgrading to VIP membership, you will enjoy multiple benefits, including up to 6% trading rebates, fast withdrawal services, a dedicated account manager, prioritized request handling, and customized trading advice. 
                        Specific benefits will depend on your VIP level.
                    </article>
                </div>
                <div>
                    <h6 className="questionSmallHeader">Q: How long does it take to complete the upgrade? Will there be any delays?</h6>
                    <article className="questionText">
                        A: The time to complete your upgrade usually depends on your trading activity and the verification process. 
                        Generally, your VIP upgrade will be processed within 24 hours after meeting the requirements. If you experience any delays, you can inquire through our customer service.
                    </article>
                </div>
                <div>
                    <h6 className="questionSmallHeader">Q: How can I find out my current VIP level and associated benefits?</h6>
                </div>
                <article className="questionText">
                    A: You can check your current VIP level and its related benefits in your account settings or profile page. 
                    If you have any questions, feel free to reach out to our customer service team for assistance.
                </article>
            </div>
        </div>
    )
}

export default Question;